module.exports = __webpack_public_path__ + "static/media/speech_bubble.1544a537.svg";